import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Input, ViewChild } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SwiperOptions } from 'swiper/types';
import { SwiperContainer } from 'swiper/element';
import { SharedModule } from '../shared.module';
import { TranslateModule } from '@ngx-translate/core';

export interface SwiperItem {
  image?: string;
  title?: string;
  subtitle?: string;
  content?: string;
  button?: {
    label?: string;
    action?:(element:any)=>void;
  };
  
}

@Component({
  selector: 'app-carousel',
  standalone: true,
  imports: [CommonModule, SharedModule, TranslateModule, NgOptimizedImage],
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CarouselComponent implements AfterViewInit {

  @ViewChild('swiper') swiper!: ElementRef<SwiperContainer>;
  @ViewChild('prevElButton') prevElButton!: ElementRef<HTMLElement>;
  @ViewChild('nextElButton') nextElButton!: ElementRef<HTMLElement>;

  @Input() items: SwiperItem[] = [];
  
  index = 0;
  slidesPerView = '3';
  // // if it was initialized with attributes
  // swiperEl.setAttribute('slides-per-view', '3');

  swiperConfig: SwiperOptions = {
   breakpoints: {
     0: {
       slidesPerView: 1
     },
     600: {
       slidesPerView: 2
     },
     960: {
       slidesPerView: 3
     }
   },
    spaceBetween: 30,
    navigation: true,
    pagination: true,
    loop: true
  };

  ngAfterViewInit() {
    this.swiper.nativeElement.swiper.activeIndex = this.index;
    this.swiper.nativeElement.swiper.navigation.nextEl = this.nextElButton.nativeElement;
    this.swiper.nativeElement.swiper.navigation.prevEl = this.prevElButton.nativeElement;
    const swiperParams = {
      breakpoints: {
        250: {
          slidesPerView: 1,
          spaceBetween:0
        },
        768: {
          slidesPerView: 2,
          spaceBetween:30
        },
        1024: {
          slidesPerView: 3,
          spaceBetween:30
        },
      },
    };

    // now we need to assign all parameters to Swiper element
    Object.assign(this.swiper.nativeElement, swiperParams);
    this.swiper.nativeElement.initialize();
  }

  slideChange(swiper: any) {
    this.index = swiper.detail[0].activeIndex;
  }

  clickedAction(item: SwiperItem) {
   if(item && item.button && item.button.action)
    try {
      item.button.action(item);
    } catch (error) {
      console.log(error, item);
    }
  }
  prevSlide() {
    this.swiper.nativeElement.swiper.slidePrev();
  }
  nextSlide() {
    this.swiper.nativeElement.swiper.slideNext();
  }
}
